module.exports = __webpack_public_path__ + "img/T4.68cb7af0.png";